import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { InboxNotiType, InboxNotiTypes, InboxNotiTypeText } from '@diritto/common/notification/constants';
import { Color } from '@diritto/common/style/color';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { Divider } from 'ui-components/common/Divider';

interface InboxTabProps {
  className?: string;
  selectedInboxNotiType: InboxNotiType;
  onChange?: (key: InboxNotiType) => void;
}

export const InboxTab = ({ className, selectedInboxNotiType, onChange }: InboxTabProps) => (
  <StyledTabMenu>
    <Divider position="bottom" />
    <StyledTabButtons className={className}>
      {InboxNotiTypes.map(inboxNotiType => (
        <StyledTabButton
          key={inboxNotiType}
          type="button"
          isSelected={selectedInboxNotiType === inboxNotiType}
          onClick={() => onChange?.(inboxNotiType)}>
          {InboxNotiTypeText[inboxNotiType]}
        </StyledTabButton>
      ))}
    </StyledTabButtons>
  </StyledTabMenu>
);

const StyledTabButtons = styled(ContentBodyContainer)`
  position: relative;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
`;

const StyledTabMenu = styled.div`
  position: relative;
  height: 44px;
`;

const StyledTabButton = styled.button(
  ({ isSelected }: { isSelected: boolean }) => css`
    height: 100%;
    color: ${isSelected ? Color.Primary500 : Color.Black};
    font-weight: ${isSelected ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XXSmall};

    border-bottom: 2px solid ${isSelected ? Color.Primary500 : 'transparent'};
  `,
);
